import { ValuationHealthDto } from "../../models/Dashboard";
import "./DashboardStyleSheet.css";


const HealthBar: React.FC<{ count?: number; total?: number; label: string }> = ({
    count, total, label
}) => {

    let pcnt = 0;
    let colour = "#dc2626";

    if (count && total) {

        pcnt = total > 0 ? Math.round(count / total * 100) : 0;
        colour = pcnt >= 80 ? "#16a34a" : pcnt >= 50 ? "#d97706" : "#dc2626";
    }

        return (
            <div className="health-row">
                <span className="health-label">{label}</span>
                <div className="health-track">
                    <div className="health-fill" style={{ width: `${pcnt}%`, background: colour }} />
                </div>
                <span className="health-pct">{pcnt}%</span>
            </div>
        );
    
};

const ValuationHealthCard: React.FC<{ health: ValuationHealthDto | undefined }> = ({ health }) => (
    <div className="dashboard-card dashboard-card--full">
        <div className="dashboard-card-header"><h2>Collection Health</h2></div>
        <div className="dashboard-card-body">
            <div className="health-bars">
                <HealthBar count={health?.withCurrentInsurance} total={health?.totalArtworks} label="Current Insurance Valuation" />
                <HealthBar count={health?.withCurrentFMV} total={health?.totalArtworks} label="Current Fair Market Value" />
                <HealthBar count={health?.withAcquisitionRecord} total={health?.totalArtworks} label="Acquisition Record" />
                <HealthBar count={health?.withImage} total={health?.totalArtworks} label="Image on Record" />
                <HealthBar count={health?.withProvenance} total={health?.totalArtworks} label="Provenance Documented" />
                <HealthBar count={health?.withDimensions} total={health?.totalArtworks} label="Dimensions Recorded" />
            </div>
        </div>
    </div>
);
export default ValuationHealthCard;